 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"basic-login-basic-login-module":"basic-login-basic-login-module","basic-reg-basic-reg-module":"basic-reg-basic-reg-module","default~analytics-analytics-module~crm-dashboard-crm-dashboard-module~default-default-module~ecommer~08b15c04":"default~analytics-analytics-module~crm-dashboard-crm-dashboard-module~default-default-module~ecommer~08b15c04","common":"common","page-reports-reports-module":"page-reports-reports-module","default~analytics-analytics-module~crm-dashboard-crm-dashboard-module~default-default-module~ecommer~93d04dc6":"default~analytics-analytics-module~crm-dashboard-crm-dashboard-module~default-default-module~ecommer~93d04dc6","analytics-analytics-module":"analytics-analytics-module","ecommerce-ecommerce-module":"ecommerce-ecommerce-module","project-project-module":"project-project-module","default~crm-dashboard-crm-dashboard-module~default-default-module":"default~crm-dashboard-crm-dashboard-module~default-default-module","crm-dashboard-crm-dashboard-module":"crm-dashboard-crm-dashboard-module","default-default-module":"default-default-module","default~forgot-forgot-module~page-aceAlertInquiry-aceAlertInquiry-module~page-agent-agent-module~pag~53eba356":"default~forgot-forgot-module~page-aceAlertInquiry-aceAlertInquiry-module~page-agent-agent-module~pag~53eba356","forgot-forgot-module":"forgot-forgot-module","page-dashboard-dashboard-module":"page-dashboard-dashboard-module","default~page-aceAlertInquiry-aceAlertInquiry-module~page-agent-agent-module~page-announcement-announ~87417a89":"default~page-aceAlertInquiry-aceAlertInquiry-module~page-agent-agent-module~page-announcement-announ~87417a89","page-assignTask-assignTask-module":"page-assignTask-assignTask-module","page-referFollowup-referFollowup-module":"page-referFollowup-referFollowup-module","page-userActivity-userActivity-module":"page-userActivity-userActivity-module","page-aceAlertInquiry-aceAlertInquiry-module":"page-aceAlertInquiry-aceAlertInquiry-module","page-movegroup-movegroup-module":"page-movegroup-movegroup-module","page-news-news-module":"page-news-news-module","page-rank-rank-module":"page-rank-rank-module","page-referenceData-referenceData-module":"page-referenceData-referenceData-module","page-result-result-module":"page-result-result-module","page-subgroup-subgroup-module":"page-subgroup-subgroup-module","page-template-template-module":"page-template-template-module","default~page-agent-agent-module~page-announcement-announcement-module~page-ataGlance-ataGlance-modul~f6b8a7c0":"default~page-agent-agent-module~page-announcement-announcement-module~page-ataGlance-ataGlance-modul~f6b8a7c0","page-agent-agent-module":"page-agent-agent-module","page-announcement-announcement-module":"page-announcement-announcement-module","page-attendance-attendance-module":"page-attendance-attendance-module","page-beAlert-beAlert-module":"page-beAlert-beAlert-module","page-birthday-birthday-module":"page-birthday-birthday-module","page-changePassword-changePassword-module":"page-changePassword-changePassword-module","page-circulars-circulars-module":"page-circulars-circulars-module","page-client-client-module":"page-client-client-module","page-examWish-examWish-module":"page-examWish-examWish-module","page-fee-fee-module":"page-fee-fee-module","page-feeAdd-feeAdd-module":"page-feeAdd-feeAdd-module","page-feeReceived-feeReceived-module":"page-feeReceived-feeReceived-module","page-feedback-feedback-module":"page-feedback-feedback-module","page-graph-graph-module":"page-graph-graph-module","page-greetings-greetings-module":"page-greetings-greetings-module","page-happenings-happenings-module":"page-happenings-happenings-module","page-homework-homework-module":"page-homework-homework-module","page-inquiries-inquiries-module":"page-inquiries-inquiries-module","page-invitation-invitation-module":"page-invitation-invitation-module","page-memo-memo-module":"page-memo-memo-module","page-notice-notice-module":"page-notice-notice-module","page-profile-profile-module":"page-profile-profile-module","page-promotion-promotion-module":"page-promotion-promotion-module","page-subscriptionRequest-subscriptionRequest-module":"page-subscriptionRequest-subscriptionRequest-module","page-subscriptionRequestsms-subscriptionRequestsms-module":"page-subscriptionRequestsms-subscriptionRequestsms-module","page-subusers-subusers-module":"page-subusers-subusers-module","default~page-attendanceReport-attendanceReport-module~page-feeReport-feeReport-module~page-manageDat~1c15c0bd":"default~page-attendanceReport-attendanceReport-module~page-feeReport-feeReport-module~page-manageDat~1c15c0bd","page-manageData-generalData-generalData-module":"page-manageData-generalData-generalData-module","page-manageData-studentData-studentData-module":"page-manageData-studentData-studentData-module","default~page-city-city-module~page-country-country-module~page-designation-designation-module~page-g~df82fa3c":"default~page-city-city-module~page-country-country-module~page-designation-designation-module~page-g~df82fa3c","page-city-city-module":"page-city-city-module","page-country-country-module":"page-country-country-module","page-designation-designation-module":"page-designation-designation-module","page-group-group-module":"page-group-group-module","page-state-state-module":"page-state-state-module","page-subject-subject-module":"page-subject-subject-module","page-subscription-subscription-module":"page-subscription-subscription-module","page-trainingRequest-trainingRequest-module":"page-trainingRequest-trainingRequest-module","page-ataGlance-ataGlance-module":"page-ataGlance-ataGlance-module","page-feeDue-feeDue-module":"page-feeDue-feeDue-module","page-inquiriesFollowup-inquiriesFollowup-module":"page-inquiriesFollowup-inquiriesFollowup-module","page-attendanceReport-attendanceReport-module":"page-attendanceReport-attendanceReport-module","page-feeReport-feeReport-module":"page-feeReport-feeReport-module","page-resultReport-resultReport-module":"page-resultReport-resultReport-module","page-smsDelivery-smsDelivery-module":"page-smsDelivery-smsDelivery-module","header-footer-login-header-footer-login-module":"header-footer-login-header-footer-login-module","header-footer-reg-header-footer-reg-module":"header-footer-reg-header-footer-reg-module","lock-screen-lock-screen-module":"lock-screen-lock-screen-module","login-login-module":"login-login-module","registration-registration-module":"registration-registration-module","social-header-footer-login-social-header-footer-login-module":"social-header-footer-login-social-header-footer-login-module","social-header-footer-reg-social-header-footer-reg-module":"social-header-footer-reg-social-header-footer-reg-module","social-login-social-login-module":"social-login-social-login-module","social-reg-social-reg-module":"social-reg-social-reg-module","theme-auth-auth-module":"theme-auth-auth-module","theme-dashboard-dashboard-module":"theme-dashboard-dashboard-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
